import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, CalendarCheck, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV } from "@/data/content";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-gray-200 shadow-crisp" : "bg-white border-gray-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Logo />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
                className={({ isActive }) =>
                  `text-[0.8rem] uppercase tracking-[0.12em] font-semibold transition-colors duration-200 hover:text-gold-600 ${
                    isActive ? "text-gold-600" : "text-navy-900"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/area-assistiti"
              data-testid="nav-area-assistiti"
              className="flex items-center gap-2 text-[0.8rem] uppercase tracking-[0.12em] font-semibold text-navy-900 hover:text-gold-600 transition-colors duration-200"
            >
              <Lock className="w-4 h-4" /> Area Assistiti
            </Link>
            <Link
              to="/prenota"
              data-testid="header-prenota-btn"
              className="flex items-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-[0.8rem] uppercase tracking-[0.1em] px-5 py-3 transition-colors duration-200"
            >
              <CalendarCheck className="w-4 h-4" /> Prenota
            </Link>
          </div>

          <button
            className="lg:hidden text-navy-900 p-2"
            onClick={() => setOpen(!open)}
            aria-label="Apri menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-5 py-4 space-y-1" data-testid="mobile-menu">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-3 text-sm uppercase tracking-[0.12em] font-semibold border-b border-gray-50 ${
                  isActive ? "text-gold-600" : "text-navy-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/area-assistiti" onClick={() => setOpen(false)} className="block py-3 text-sm uppercase tracking-[0.12em] font-semibold text-navy-900">
            Area Assistiti
          </Link>
          <Link
            to="/prenota"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 bg-gold-500 text-navy-900 font-bold text-sm uppercase tracking-[0.1em] px-5 py-3"
          >
            <CalendarCheck className="w-4 h-4" /> Prenota un appuntamento
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
